
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src1738611268/src/vl-app/pages/clinician/timeline.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@hooks/useRouter';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import formatDate from 'vl-common/src/lib/formatDate';
import Header from '@components/Layouts/Header/Header';
import PageHead from '@components/Layouts/PageHead/PageHead';
import Tab from '@components/UI/Tabs/Tab';
import HistoryTimeline from '@components/History/Timeline';

import LetterDocuments from '@components/Documents/LetterDocuments';
import AssessmentTable from '@components/Assessments/AssessmentTable';
import Recordings from '@components/Recordings/Recordings';

const ClinicianTimeline = ({ caseId, appId, patientGuid }) => {
  const router = useRouter();
  const [title, setTitle] = useState<{ item_condition: string; case_created_date: Date }>(undefined);
  const { app } = router.query;
  const tabs = useMemo(() => {
    const tabContents = [
      <HistoryTimeline pageTitle={setTitle} key="1" caseId={caseId} patientGuid={patientGuid} />,
      <AssessmentTable key="2" caseId={caseId} />
    ];
    if (app) {
      return [
        ...tabContents,
        <LetterDocuments key="2" caseId={caseId} appId={appId} />,
        <Recordings key="4" appId={appId} />
      ];
    }

    return tabContents;
  }, []);
  return (
    <>
      <Header pageType="clinician" pageTitle="Timeline" />

      <section className="section-layout">
        <PageHead
          backArrow
          backText={`Condition: ${title?.item_condition ?? ''}`}
          backDesc={`Case Created: ${
            title?.case_created_date
              ? formatDate(title.case_created_date, 'Long Date with day-of-week - Thursday, March 3rd, 2022')
              : ''
          }`}
        />
        <main className="container" id="page-content">
          <Tab
            tabNames={
              app
                ? ['Appointment History', 'Assessments', 'Documents', 'Recordings']
                : ['Appointment History', 'Assessments']
            }
            tabContent={tabs}
          />
        </main>
      </section>
    </>
  );
};

const ClinicianTimelineWrapper = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const { query } = useRouter();
  const appId = Buffer.from(`${query.app}`, 'base64').toString();
  const caseId = Buffer.from(`${query.req}`, 'base64').toString();
  const patientGuid = Buffer.from(`${query.patient_guid}`, 'base64').toString();
  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return <ClinicianTimeline appId={appId} caseId={caseId} patientGuid={patientGuid} />;
};


export const Route = createFileRoute('/clinician/timeline')({ component: ClinicianTimelineWrapper });
